import { useEffect } from "react";
import { createContext, useState } from "react";
import {toast} from "react-toastify";
// import All_product from '../Components/Assets/all_product'
export const ShopContext = createContext(null);
const url=process.env.REACT_APP_Backend_URL;

const get_default_cart = () => {
    let cart = {};
    for (let index = 0; index < 300 + 1; index++) {
        cart[index] = 0;
    }
    return cart;
}
const ShopContextProvider = (props) => {
    const [All_product, setAllproduct] = useState([]);
    const [cartitem, setcartitem] = useState(get_default_cart());

    useEffect(() => {
        const fetch_data = async () => {
            const id= toast.loading("Fetching data ...");
            try {
                await fetch(`${url}/allproduct`)
                    .then((response) => response.json())
                    .then((data) => setAllproduct(data));
                    toast.update(id, {render: "Data Fetched Succefully", type: "success", isLoading: false,autoClose: 1000});
            } catch (error) {
                toast.update(id, {render: "server is down", type: "error", isLoading: false});
            }
        }
        
        fetch_data();
        const feth_user=async()=>{
           try {
            if(localStorage.getItem("auth-token")){
              await  fetch(`${url}/getcart`,{
                    method:"POST",
                    headers:{
                        Accept:"application/json",
                        "auth-token":`${localStorage.getItem("auth-token")}`,
                        "Content-Type":"application/json",
                    },
                    body:"",
                }).then((res)=>res.json())
                .then((data)=>setcartitem(data))
            }
           } catch (error) {
            console.log("server is down");
           }

        }
        feth_user();
    }, [])

    const add_to_cart = (itemid) => {
        setcartitem((prev) => ({ ...prev, [itemid]: prev[itemid] + 1 }))
        if(localStorage.getItem("auth-token")){
            fetch(`${url}/addtocart`,{
                method:"POST",
                headers:{
                    Accept:"application/json",
                    'auth-token':`${localStorage.getItem("auth-token")}`,
                    'Content-Type':"application/json",
                },
                body:JSON.stringify({"itemId":itemid}),
            })
            .then((resp)=>resp.json())
            .then((data)=>console.log(data))
        }
    }
    const remove_to_cart = (itemid) => {
        setcartitem((prev) => ({ ...prev, [itemid]: prev[itemid] - 1 }))
        if(localStorage.getItem("auth-token")){
            fetch(`${url}/removetocart`,{
                method:"POST",
                headers:{
                    Accept:"application/json",
                    'auth-token':`${localStorage.getItem("auth-token")}`,
                    'Content-Type':"application/json",
                },
                body:JSON.stringify({"itemId":itemid}),
            })
            .then((resp)=>resp.json())
            .then((data)=>console.log(data))
        }
    }
    const get_total_cart_ammount = () => {
        let total_amount = 0;
        for (const item in cartitem) {
            if (cartitem[item] > 0) {
                let iteminfo = All_product.find((product) => product.id === Number(item));
                total_amount += iteminfo.new_price * cartitem[item];
            }
        }
        return total_amount;
    }
    const get_total_cart_items = () => {
        let total_item = 0;
        for (const item in cartitem) {
            if (cartitem[item] > 0) {
                total_item += cartitem[item];
            }
        }
        return total_item;
    }

    const ContextValue = { All_product, get_total_cart_items, get_total_cart_ammount, cartitem, add_to_cart, remove_to_cart,url };
    return (
        <ShopContext.Provider value={ContextValue}>
            {props.children}
        </ShopContext.Provider>
    )
}

export default ShopContextProvider;